<template>
  <div>
    <v-row class="pb-16">
      <v-col cols="12" md="7" v-if="$vuetify.breakpoint.smAndDown">
        <v-img contain src="~@/assets/images/mainpage.gif" />
      </v-col>
      <v-col cols="12" md="5" class="d-flex align-center">
        <div class="text-center" v-if="$vuetify.breakpoint.smAndDown">
          <div class="dastnevis">
            <div>
              ســـامـــانـه
              <span v-if="!this.$store?.getters?.hasDefaultPortal">
                تـوسـعـه ســواد خـوانـدن
              </span>
            </div>
            <p
              v-if="!this.$store?.getters?.hasDefaultPortal"
              class="mt-1 mb-3"
              style="font-size: 50px; font-weight: bold"
            >
              {{ this.$store?.getters?.portal?.title }}
            </p>
            <div v-else>
              <p class="mt-1 mb-3" style="font-size: 60px; font-weight: bold">
                توسعه سواد خواندن
              </p>
              <p class="ma-0">مـــدرســـه مــا</p>
            </div>
          </div>
          <div
            v-if="!this.$store?.getters?.hasDefaultPortal"
            class="text-h4 grey--text lighten-2 mt-16 pl-16"
          >
            {{ this.$store?.getters?.portal?.description }}
          </div>
          <div v-else class="text-h4 grey--text lighten-2 mt-16 pl-16">
            خواندن؛ یک مهارت بنیادین همگانی و همیشگی است
          </div>
          <v-btn
            :class="
              $vuetify.breakpoint.mdAndUp
                ? 'mt-16 text-h5 white--text px-16'
                : 'mt-12 text-h6 white--text px-10'
            "
            depressed
            shaped
            x-large
            color="success"
            router
            to="Books"
          >
            شـــروع کـــن
          </v-btn>
        </div>
        <div v-if="$vuetify.breakpoint.mdAndUp">
          <div class="dastnevis">
            <div>
              ســـامـــانـه
              <span v-if="!this.$store?.getters?.hasDefaultPortal">
                تـوسـعـه ســواد خـوانـدن
              </span>
            </div>
            <p
              v-if="!this.$store?.getters?.hasDefaultPortal"
              class="mt-1 mb-3"
              style="font-size: 50px; font-weight: bold"
            >
              {{ this.$store?.getters?.portal?.title }}
            </p>
            <div v-else>
              <p class="mt-1 mb-3" style="font-size: 60px; font-weight: bold">
                توسعه سواد خواندن
              </p>
              <p class="ma-0">مـــدرســـه مــا</p>
            </div>
          </div>
          <div
            v-if="!this.$store?.getters?.hasDefaultPortal"
            class="text-h4 grey--text lighten-2 mt-16 pl-16"
          >
            {{ this.$store?.getters?.portal?.description }}
          </div>
          <div v-else class="text-h4 grey--text lighten-2 mt-16 pl-16">
            خواندن؛ یک مهارت بنیادین همگانی و همیشگی است
          </div>
          <v-btn
            class="mt-16 text-h5 white--text px-16"
            depressed
            shaped
            x-large
            color="success"
            router
            to="Books"
          >
            شـــروع کـــن
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="7" v-if="$vuetify.breakpoint.mdAndUp">
        <v-img contain src="~@/assets/images/mainpage.gif" />
      </v-col>
    </v-row>

    <div v-if="$vuetify.breakpoint.mdAndUp" class="text-center">
      <v-btn
        ref="button"
        depressed
        fab
        class="my-16"
        @click="
          $vuetify.goTo('#feature', {
            duration: 1000,
            offset: 20,
            easing: 'easeInOutCubic'
          })
        "
      >
        <v-icon class="text-h2 my-10"> mdi-chevron-down </v-icon>
      </v-btn>
    </div>

    <v-row id="feature" class="mb-md-16 py-md-16 py-10 text-center">
      <v-col cols="12" md="4" sm="5" class="d-flex align-center">
        <div
          class="flex-fill text-h6 font-weight-bold text-center"
          style="font-family: 'iransansdn' !important"
          v-if="$vuetify.breakpoint.smAndDown"
        >
          چرا سواد خواندن مهم است؟
        </div>
        <div v-if="$vuetify.breakpoint.mdAndUp">
          <div class="text-h4" style="font-family: 'iransansdn' !important">
            چرا
          </div>
          <div
            class="py-6 mb-3 dastnevis"
            style="font-size: 60px; font-weight: bold"
          >
            سـوادخـوانـدن
          </div>
          <div class="text-h4" style="font-family: 'iransansdn' !important">
            مهم است؟
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="8" sm="7">
        <div class="re-video-bg bg-1">
          <vue-plyr>
            <video src="https://dl.pirls.ir/app/Importance.mp4"></video>
          </vue-plyr>
        </div>
      </v-col>
    </v-row>

    <v-row class="my-md-16 py-md-16 py-10 text-center">
      <v-col v-if="$vuetify.breakpoint.smAndDown" cols="12">
        <div
          class="flex-fill text-h6 font-weight-bold text-center"
          style="font-family: 'iransansdn' !important"
        >
          چگونه سواد خواندن را توسعه دهیم؟
        </div>
      </v-col>
      <v-col cols="12" md="8" sm="7">
        <div class="re-video-bg bg-2">
          <vue-plyr>
            <video src="https://dl.pirls.ir/app/Why.mp4"></video>
          </vue-plyr>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="5"
        class="d-flex align-center"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <div>
          <div class="text-h4" style="font-family: 'iransansdn' !important">
            چگونه
          </div>
          <div
            class="py-6 mb-3 dastnevis"
            style="font-size: 60px; font-weight: bold"
          >
            سـوادخـوانـدن
          </div>
          <div class="text-h4" style="font-family: 'iransansdn' !important">
            را توسعه دهیم؟
          </div>
        </div>
      </v-col>
    </v-row>

    <div>
      <v-row class="border-bottom" v-for="item in items" :key="item.id">
        <v-col
          md="4"
          v-if="
            (item.right && $vuetify.breakpoint.mdAndUp) ||
            $vuetify.breakpoint.smAndDown
          "
          class="text-center"
        >
          <v-img contain :src="item.image">
            <div class="fill-height bottom-gradient" />
          </v-img>
        </v-col>
        <v-col class="d-flex">
          <div class="flex-fill align-self-center px-8">
            <h1 :class="item.color">
              {{ item.title }}
            </h1>
            <v-card class="grey lighten-5" elevation="1">
              <div class="text-subtitle-1 pa-7 text-justify">
                {{ item.text }}
              </div>
            </v-card>
          </div>
        </v-col>
        <v-col
          md="5"
          v-if="!item.right && $vuetify.breakpoint.mdAndUp"
          class="text-center"
        >
          <v-img contain :src="item.image">
            <div class="fill-height bottom-gradient" />
          </v-img>
        </v-col>
      </v-row>
    </div>
    <div class="text-center my-10">
      <v-btn
        class="my-10 text-h6 white--text px-10"
        depressed
        shaped
        large
        color="red accent-2"
        router
        to="Books"
      >
        شـــروع کـــن
      </v-btn>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home-component",
  data() {
    return {
      items: [
        {
          id: "1",
          image: require("@/assets/images/feature/01.jpg"),
          color: "mb-5 dastnevis red--text darken-1",
          title: "بخوانیم",
          text: "در این سامانه دانش آموزان می توانند 36 جلد کتاب داستان جذاب مناسب سن خود را در قالب هر کتاب یک داستان با یک موضوع ارزش اخلاقی یا مهارت های زندگی را مطالعه کنند، صدای آن را گوش کنند فیلم آن را مشاهده کرده و از آن لذت ببرند",
          right: true
        },
        {
          id: "2",
          image: require("@/assets/images/feature/02.jpg"),
          color: "mb-5 dastnevis amber--text accent-4",
          title: "بسنجیم",
          text: "در این سامانه دانش آموزان می توانند بعد از خواندن هر کتاب میزان درک مطلب خود را با سنجه های مناسب در چهار سطح تمرکز، استنباط، تفسیر و ارزیابی بسنجند و کارنمای عملکرد خودشان را به همراه تقدیرنامه هر کتاب از سامانه دریافت نمایند",
          right: false
        },
        {
          id: "3",
          image: require("@/assets/images/feature/03.jpg"),
          color: "mb-5 dastnevis purple--text darken-3",
          title: "رشد کنیم",
          text: "در این سامانه پدر و مادرها هم می توانند راهنمای بهبود درک مطلب دانش‌آموزان را همراه راهنمای رشد ارزش اخلاقی و مهارت های زندگی هر کتاب را در کنار راهنمای توسعه هوش های چندگانه و هوش هیجانی کتاب مربوطه را دریافت کنند",
          right: true
        }
      ]
    };
  }
};
</script>

<style scoped>
.re-video-bg {
  padding: 11% 13% 3.5% 2.5%;
  background-size: 100% !important;
}
.re-video-bg.bg-1 {
  background: url("~@/assets/images/video-bg-1.svg") no-repeat top center;
}
.re-video-bg.bg-2 {
  background: url("~@/assets/images/video-bg-2.svg") no-repeat top center;
  padding: 3% 2.5% 12% 12.5%;
}
</style>
